export default {"src":"/_next/static/media/heart-filled-white-46x46.4572e11e.svg","height":19,"width":22};